export const customTheme = {
  colors: {
    background: "#fff",
    main: "#001529",
    secondary: "#131313",
    tableBorder: "#c7c7c7",
  },
};
